import { SVGProps } from "react";

export default function EditIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5059_17686)">
        <path
          d="M4.79999 16.8688V19.3008C4.79999 19.5248 4.97599 19.7008 5.19999 19.7008H7.63199C7.73599 19.7008 7.83999 19.6608 7.91199 19.5808L16.648 10.8528L13.648 7.85283L4.91999 16.5808C4.83999 16.6608 4.79999 16.7568 4.79999 16.8688ZM18.968 8.53283C19.28 8.22083 19.28 7.71683 18.968 7.40483L17.096 5.53283C16.784 5.22083 16.28 5.22083 15.968 5.53283L14.504 6.99683L17.504 9.99683L18.968 8.53283Z"
          fill="#757575"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_5059_17686">
          <rect width="19.2" height="19.2" fill="white" transform="translate(2.39999 2.90039)" />
        </clipPath>
      </defs>
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="16"
    //   height="16"
    //   viewBox="0 0 16 16"
    //   fill="none"
    //   {...props}
    // >
    //   <g clipPath="url(#clip0_2335_124148)">
    //     <path
    //       d="M2 11.64V13.6666C2 13.8533 2.14667 14 2.33333 14H4.36C4.44667 14 4.53333 13.9666 4.59333 13.9L11.8733 6.62662L9.37333 4.12662L2.1 11.4C2.03333 11.4666 2 11.5466 2 11.64ZM13.8067 4.69329C14.0667 4.43329 14.0667 4.01329 13.8067 3.75329L12.2467 2.19329C11.9867 1.93329 11.5667 1.93329 11.3067 2.19329L10.0867 3.41329L12.5867 5.91329L13.8067 4.69329Z"
    //       fill="currentColor"
    //     />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_2335_124148">
    //       <rect width="16" height="16" fill="currentColor" />
    //     </clipPath>
    //   </defs>
    // </svg>
  );
}
